import * as React from "react";
import MyAccount from "@route-planner/components/MyAccount";

const Component = (props) => {
  return <MyAccount />;
};

const page = {
  routeProps: {
    path: "MyAccount",
    component: Component,
  },
  name: "My Account",
  label: "My Account",
  title: "My Account",
  showOnMenu: true,
};

export default page;
